import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import posterImg from "../../assets/images/special-campaign-6-banner.jpg";
import { SC6_NAME, SC6_SCHOOL_PATH, SC6_TITLE, SC6_UNDER } from "../SpecialCampaign6/sc6Config";
import useBackdropClose from "./useBackdropClose";
import "./Sc6PromptModal.css";

/*
 * National Event on 28 Oct 2026 (under Special Campaign 6) — post-login prompt.
 * Shown by OutletRouteSchool, once per login, while the school has not
 * uploaded its participation details (status comes with /swachhata/status —
 * no extra call). "Fill now" opens the form inside the dashboard
 * (/school/special-campaign-6); "Later" dismisses for this session.
 */
export default function Sc6PromptModal({ isOpen, onDismiss }) {
  const navigate = useNavigate();
  const backdrop = useBackdropClose(onDismiss);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => e.key === "Escape" && onDismiss();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onDismiss]);

  if (!isOpen) return null;
  return (
    <div className="s6p-overlay" role="dialog" aria-modal="true" aria-labelledby="s6p-title" {...backdrop}>
      <div className="s6p-card">
        <div className="s6p-media">
          <img src={posterImg} alt="" />
        </div>
        <div className="s6p-body">
          <span className="s6p-chip">{SC6_UNDER}</span>
          <h2 id="s6p-title" className="s6p-title">{SC6_NAME}</h2>
          <p className="s6p-sub">{SC6_TITLE}</p>
          <p className="s6p-lead">
            Did your school take part? Upload the participation details — the quiz in the morning assembly, E-Waste items collected,
            disposal to an authorised recycler, students participated and 2–3 geotagged photos.
          </p>
          <div className="s6p-actions">
            <button type="button" className="s6p-btn s6p-btn--primary" onClick={() => { onDismiss(); navigate(SC6_SCHOOL_PATH); }}>
              Fill participation details
            </button>
            <button type="button" className="s6p-btn s6p-btn--ghost" onClick={onDismiss}>
              Later
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
